/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tld_Pricing_Status_FilterInputs */

const id_tld_pricing_status_filter = /** @type {(inputs: Tld_Pricing_Status_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saring status`)
};

const en_tld_pricing_status_filter = /** @type {(inputs: Tld_Pricing_Status_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter by status`)
};

/**
* | output |
* | --- |
* | "Filter by status" |
*
* @param {Tld_Pricing_Status_FilterInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_status_filter = /** @type {((inputs?: Tld_Pricing_Status_FilterInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_Status_FilterInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_status_filter(inputs)
	return id_tld_pricing_status_filter(inputs)
});